"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbaColor = rgbaColor;
function rgbaColor(color, opacity) {
    const adjustedOpacity = Math.min(1, Math.max(0, opacity));
    const bareHex = color.replace("#", "");
    // Expand short form hex codes if necessary
    const hex = bareHex.length === 3
        ? bareHex
            .split("")
            .map((char) => char + char)
            .join("")
        : bareHex;
    const [red, green, blue] = [0, 2, 4].map((offset) => parseInt(hex.substring(offset, offset + 2), 16));
    return `rgba(${red}, ${green}, ${blue}, ${adjustedOpacity})`;
}
//# sourceMappingURL=Colors.utils.js.map